var map = {
	"./App": "3dfd",
	"./App.vue": "3dfd",
	"./assets/Background image 2.jpeg": "c63b",
	"./assets/Background image.ai": "00e4",
	"./assets/Backgrounds/Background image 2.jpeg": "a7ad",
	"./assets/Backgrounds/Background image 3.jpeg": "d5bf",
	"./assets/Backgrounds/Diwali 2.jpeg": "c740",
	"./assets/Backgrounds/Diwali 3.jpeg": "ede3",
	"./assets/Backgrounds/Diwali 4.jpeg": "2435",
	"./assets/Backgrounds/Diwali.jpeg": "9cb1",
	"./assets/Backgrounds/Dusshera 2.jpeg": "dac4",
	"./assets/Backgrounds/Dusshera 3.jpeg": "dcb9",
	"./assets/Backgrounds/Dusshera.jpeg": "35b9",
	"./assets/Backgrounds/Holi 2.jpeg": "c7bf",
	"./assets/Backgrounds/Holi 3.jpeg": "682a",
	"./assets/Backgrounds/Holi.jpeg": "8857",
	"./assets/Backgrounds/Independence Day 2.jpeg": "6b6d",
	"./assets/Backgrounds/Independence Day.jpeg": "cdd6",
	"./assets/Backgrounds/India 2.jpeg": "f4fd",
	"./assets/Backgrounds/India.jpeg": "49c4",
	"./assets/Backgrounds/New Year 2.jpeg": "3b9b",
	"./assets/Backgrounds/New Year 3.jpeg": "d848",
	"./assets/Backgrounds/New Year 4.jpeg": "b752",
	"./assets/Backgrounds/New Year 5.jpeg": "cbcd",
	"./assets/Backgrounds/New Year 6.jpeg": "0aac",
	"./assets/Backgrounds/New Year 7.jpeg": "f03b",
	"./assets/Backgrounds/New Year.jpeg": "a0d7",
	"./assets/Backgrounds/Republic Day.jpeg": "29fd",
	"./assets/Contact.jpeg": "cd3b",
	"./assets/Emails.jpeg": "224c",
	"./assets/Hero Images/Diwali.jpeg": "ede7",
	"./assets/Hero Images/Hero Image 2.jpeg": "6ec0",
	"./assets/Hero Images/Hero Image 3.jpeg": "bef9",
	"./assets/Hero Images/Hero Image 4.jpeg": "333b",
	"./assets/Hero Images/Hero Image.jpeg": "6263",
	"./assets/Hero Images/Sanskrit.jpeg": "3996",
	"./assets/Nav Logo.jpg": "36f3",
	"./assets/Phone 2.jpeg": "bd6e",
	"./assets/Prep.jpeg": "dfe1",
	"./assets/Preparation.jpeg": "9b4c",
	"./assets/Programs.jpeg": "b582",
	"./assets/Resources 2.jpeg": "fd7a",
	"./assets/Team.jpeg": "dc95",
	"./assets/Vision.jpeg": "d490",
	"./assets/about us.jpeg": "e68c",
	"./assets/email.png": "9afb",
	"./assets/global background.jpeg": "dc22",
	"./assets/logo.png": "cf05",
	"./assets/logo.svg": "9b19",
	"./assets/mission.jpeg": "8212",
	"./assets/page logo copy 2.png": "799e",
	"./assets/page logo.png": "f6fe",
	"./assets/phone.jpeg": "9e04",
	"./assets/program.jpeg": "315c",
	"./assets/resources.jpeg": "33ad",
	"./components/AppNavigation": "19e2",
	"./components/AppNavigation.vue": "19e2",
	"./components/ContactDetails": "36e0",
	"./components/ContactDetails.vue": "36e0",
	"./components/ExamPrep": "1421",
	"./components/ExamPrep.vue": "1421",
	"./components/Footer": "fd2d",
	"./components/Footer.vue": "fd2d",
	"./components/GetStarted": "5f40",
	"./components/GetStarted.vue": "5f40",
	"./components/HelloWorld": "fdab",
	"./components/HelloWorld.vue": "fdab",
	"./components/HomeHero": "f806",
	"./components/HomeHero.vue": "f806",
	"./components/HomeScroller": "0a32",
	"./components/HomeScroller.vue": "0a32",
	"./components/Mission": "1809",
	"./components/Mission.vue": "1809",
	"./components/NeedHelp": "e9ec",
	"./components/NeedHelp.vue": "e9ec",
	"./components/PrepDetails": "7830",
	"./components/PrepDetails.vue": "7830",
	"./components/ResourceDetails": "cb73",
	"./components/ResourceDetails.vue": "cb73",
	"./components/Scroller": "dd73",
	"./components/Scroller.vue": "dd73",
	"./components/ShareButton": "b55c",
	"./components/ShareButton.vue": "b55c",
	"./components/Timeline": "da9e",
	"./components/Timeline.vue": "da9e",
	"./copy/AboutUs": "5c4f",
	"./copy/AboutUs.json": "5c4f",
	"./copy/Contacts": "8636",
	"./copy/Contacts.json": "8636",
	"./copy/ExamMaterial": "844d",
	"./copy/ExamMaterial-backup-2ndDec2023": "9593",
	"./copy/ExamMaterial-backup-2ndDec2023.json": "9593",
	"./copy/ExamMaterial-modified-5thAug2025": "5539",
	"./copy/ExamMaterial-modified-5thAug2025.json": "5539",
	"./copy/ExamMaterial.json": "844d",
	"./copy/GetStartedSection": "cf6d",
	"./copy/GetStartedSection.json": "cf6d",
	"./copy/HelpSection": "cd5c",
	"./copy/HelpSection.json": "cd5c",
	"./copy/ResourceCards": "9950",
	"./copy/ResourceCards.json": "9950",
	"./copy/TimelineCards": "743b",
	"./copy/TimelineCards.json": "743b",
	"./main": "56d7",
	"./main.js": "56d7",
	"./plugins/vuetify": "402c",
	"./plugins/vuetify.js": "402c",
	"./router": "a18c",
	"./router/": "a18c",
	"./router/index": "a18c",
	"./router/index.js": "a18c",
	"./store": "4360",
	"./store/": "4360",
	"./store/BlogPosts": "2348",
	"./store/BlogPosts.json": "2348",
	"./store/index": "4360",
	"./store/index.js": "4360",
	"./views/About": "f820",
	"./views/About.vue": "f820",
	"./views/Contact": "b8fa",
	"./views/Contact.vue": "b8fa",
	"./views/Home": "bb51",
	"./views/Home.vue": "bb51",
	"./views/Preparation": "a188",
	"./views/Preparation.vue": "a188",
	"./views/Programs": "0cc5",
	"./views/Programs.vue": "0cc5",
	"./views/Resources": "93b9",
	"./views/Resources.vue": "93b9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a8ec";